import React from "react";
import { Avatar, Grid, Divider, Typography } from "@mui/material";
import Banner from "../../../assets/images/leftsquremenu/pos-banner.png";
import Visitor from "../../../assets/images/leftsquremenu/visitor.png";
import NewOrder from "../../../assets/images/leftsquremenu/new-order.png";
import Sales from "../../../assets/images/leftsquremenu/sales.png";
import Shipping from "../../../assets/images/leftsquremenu/shipping.png";

const infos = [
  { icon: Visitor, title: "Visitors", amount: "156 k" },
  { icon: NewOrder, title: "New Order", amount: "1500 k" },
  { icon: Sales, title: "Sales", amount: "1006 k" },
  { icon: Shipping, title: "Shipping", amount: "1256 k" },
];

const Pos = () => {
  return (
    <div>
      <PageContentBox infos={infos} />
    </div>
  );
};

const PageContentBox = ({ infos }) => (
  <div
    style={{
      margin: 30,
    }}
  >
    <Avatar
      sx={{
        width: 1010,
        height: 422,
      }}
      variant="square"
      src={Banner}
    />

    <FourBoxes infos={infos} />
  </div>
);

const FourBoxes = ({ infos }) => (
  <div style={{ marginLeft: 30, marginTop: 20 }}>
    <Typography
      align="left"
      style={{
        color: "#424242",
        fontWeight: "600",
        fontFamily: `'Noto Sans', sans-serif`,
      }}
    >
      Lorem Ipsum
    </Typography>
    <CustomeDivider />

    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      {infos.map((item, index) => (
        <ItemBox item={item} key={index} />
      ))}
    </Grid>
  </div>
);

const ItemBox = ({ item }) => (
  <div
    style={{
      width: 223,
      height: 156,
      background: "#D9D9D9",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Avatar
      sx={{
        width: "55px",
        height: "55px",
      }}
      variant="square"
      src={item.icon}
    />
    <div
      style={{
        fontSize: 16,
        width: 95,
        height: 29,
        border: `1px solid #949494`,
        borderRadius: 4,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "10px 0",
        fontWeight: "400",
        fontFamily: `'Noto Sans', sans-serif`,
      }}
    >
      {item.title}
    </div>
    <div
      style={{
        fontSize: 16,
        fontWeight: "500",
        fontFamily: `'Noto Sans', sans-serif`,
      }}
    >
      {item.amount}
    </div>
  </div>
);

const CustomeDivider = () => (
  <div style={{ paddingBottom: "20px", paddingTop: "7px" }}>
    <Divider
      style={{
        background: "#E5E5E5",
        margin: "0 0 0 0",
        maxWidth: "100%",
        height: "2.25px",
      }}
    />
    <Divider
      style={{
        background: "#CA2129",
        margin: "-3px 0 0 0",
        maxWidth: "170px",
        height: "3px",
      }}
    />
  </div>
);

export default Pos;
